import React, { Component } from "react"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogActions from "@mui/material/DialogActions"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import Grow from "@mui/material/Grow"
import Collapse from "@mui/material/Collapse"
import CircularProgress from "@mui/material/CircularProgress"
import Alert from "@mui/lab/Alert"
import LoadingButton from "@mui/lab/LoadingButton"
import Done from "@mui/icons-material/Done"
import Close from "@mui/icons-material/Close"
import { withTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import { ListItem, ListItemText, Switch } from "@mui/material"

export default withTranslation()(
  withRouter(
    class UploadExperienceDialog extends Component {
      state = {
        name: "",
        nameEmpty: null,
        nameError: null,
        file: null,
        assets: null,
        loading: false,
        error: null,
        openPermission: false,
      }

      createExperience = (name, body, assets, close, openPermission) => {
        const { history, setExperiences, experiences } = this.props

        this.setState({ loading: true })

        fetch(
          `${
            process.env.REACT_APP_SERVER_URL
          }/experiences?name=${name}&password=${localStorage.getItem(
            "password"
          )}` + (openPermission ? "&permission=open" : ""),
          {
            method: "POST",
            body,
            headers: { "Content-Type": "text/yaml" },
          }
        )
          .then((response) => {
            if (response.status === 422) {
              response
                .text()
                .then((error) => this.setState({ error, file: null }))

              this.assetsUpload.value = ""
            } else {
              response.json().then(async (experience) => {
                await assets.forEach(async (body, index) => {
                  const fileName = body.name

                  await fetch(
                    `${process.env.REACT_APP_SERVER_URL}/experiences/${
                      experience._id
                    }/assets?password=${localStorage.getItem(
                      "password"
                    )}&fileName=${fileName}`,
                    {
                      method: "POST",
                      body,
                      headers: { "Content-Type": "application/octet-stream" },
                    }
                  )
                    .then(() => {
                      if (index === assets.length - 1) {
                        setExperiences([
                          ...experiences.filter(
                            ({ _id }) => _id !== experience._id
                          ),
                          {
                            ...experience,
                            assets: [
                              ...experience.assets,
                              ...assets.map(({ name }) => name),
                            ],
                          },
                        ])

                        history.push(`/admin?experience=${experience._id}`)

                        close()
                      }

                      this.setState({ error: null })
                    })
                    .catch(() => {})
                })
              })
            }

            this.setState({ loading: false })
          })
          .catch(() =>
            this.setState({
              loading: false,
            })
          )
      }

      componentWillReceiveProps(nextProps) {
        if (nextProps.open && !this.props.open) {
          this.setState({
            name: "",
            nameEmpty: null,
            nameError: null,
            file: null,
            assets: null,
            error: null,
            loading: false,
          })
        }
      }

      render() {
        const { open, close, t } = this.props
        const {
          name,
          nameEmpty,
          nameError,
          file,
          assets,
          loading,
          error,
          openPermission,
        } = this.state

        return (
          <Dialog
            open={open}
            onClose={close}
            TransitionComponent={Grow}
            maxWidth="sm"
          >
            <DialogTitle
              className="notSelectable"
              style={{ fontWeight: 600 }}
            >{t`Create a new experience`}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <TextField
                  fullWidth
                  label={t`Experience name`}
                  variant="outlined"
                  style={{ textTransform: "none" }}
                  margin="normal"
                  value={name}
                  error={nameEmpty || !!nameError}
                  helperText={
                    nameEmpty ? t`This field is required` : nameError || " "
                  }
                  onChange={(event) =>
                    this.setState({
                      name: event.target.value,
                      nameEmpty: event.target.value.replace(/\s/g, "") === "",
                      nameError: "",
                    })
                  }
                  onKeyPress={(event) => {
                    if (
                      event.key === "Enter" &&
                      name &&
                      !nameError &&
                      file &&
                      assets
                    ) {
                      this.createExperience(name, file, assets, close)
                    }
                  }}
                />
                <input
                  type="file"
                  hidden
                  accept=".txt, .yml|text/*"
                  ref={(ref) => (this.templateUpload = ref)}
                  onChange={(event) => {
                    event.stopPropagation()
                    event.preventDefault()
                    this.setState({ file: event.target.files[0], error: null })
                  }}
                />
                <Button
                  variant="outlined"
                  onClick={() => this.templateUpload.click()}
                  style={{
                    height: "48px",
                    width: "calc(50% - 8px)",
                    marginRight: "16px",
                  }}
                  startIcon={<Done style={{ opacity: file ? 1 : 0 }} />}
                >
                  <font
                    style={{ marginRight: "24px" }}
                  >{t`Upload template`}</font>
                </Button>
                <input
                  type="file"
                  hidden
                  multiple
                  ref={(ref) => (this.assetsUpload = ref)}
                  onChange={(event) => {
                    event.stopPropagation()
                    event.preventDefault()
                    this.setState({ assets: Array.from(event.target.files) })
                  }}
                />
                <Button
                  variant="outlined"
                  onClick={() => this.assetsUpload.click()}
                  style={{
                    height: "48px",
                    width: "calc(50% - 8px)",
                  }}
                  startIcon={<Done style={{ opacity: assets ? 1 : 0 }} />}
                >
                  <font
                    style={{ marginRight: "24px" }}
                  >{t`Upload assets`}</font>
                </Button>
                <ListItem style={{ marginTop: "24px", padding: 0 }}>
                  <ListItemText
                    primary={t`Allow users to create new rooms`}
                    style={{ color: "black" }}
                  />
                  <Switch
                    edge="end"
                    onChange={(openPermission) =>
                      this.setState({ openPermission })
                    }
                    value={openPermission}
                  />
                </ListItem>
                <Collapse in={error}>
                  <Alert
                    variant="outlined"
                    severity="error"
                    style={{ marginTop: "24px" }}
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => this.setState({ error: null })}
                      >
                        <Close fontSize="inherit" />
                      </IconButton>
                    }
                  >
                    {error}
                  </Alert>
                </Collapse>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={close}>{t`Close`}</Button>
              <LoadingButton
                loading={loading}
                loadingIndicator={<CircularProgress size={16} />}
                color="primary"
                style={{ fontWeight: 600 }}
                disabled={!name || nameError || !file || !assets}
                onClick={() =>
                  this.createExperience(
                    name,
                    file,
                    assets,
                    close,
                    openPermission
                  )
                }
              >{t`Create`}</LoadingButton>
            </DialogActions>
          </Dialog>
        )
      }
    }
  )
)
